import { InjectedConnector } from "@web3-react/injected-connector";

export const RINKEBY_SCAN_API = "https://api-rinkeby.etherscan.io/api";
export const GOERLI_SCAN_API = "https://api-goerli.etherscan.io/api";

export const GEORLI_SCAN_API = "https://api-goerli.etherscan.io/api";
export const POLYGON_SCAN_API = "https://api.polygonscan.com/api";
export const POLYGON_SCAN_API_KEY = "5QGK9BBVUQRPXVT7QVZ3I6RGEACHSUSU94";

export const SERVER_BASE_URL_PROD = "https://test-backend.ember.app";
// "https://backend.ember.app";

export const SERVER_BASE_URL = "https://test-backend.ember.app";
// "http://3.141.0.105:3000";
// export const SERVER_BASE_URL = "https://8164-72-255-62-27.ngrok.io/ember-test/";

export const ETHERSCAN_API_KEY = "3SAJ8EXQMXKXDFZPW14S2XVFKPIGZ6JMW2";
export const ETHERSCAN_API = "https://api.etherscan.io/api";

export const IMAGE_URL = "https://via.placeholder.com/250x300.png";

export const SUBGRAPH_URL =
  "https://api.thegraph.com/subgraphs/name/pro123908/embermainnetv2";
// "https://api.thegraph.com/subgraphs/name/pro123908/emberrinkebyv2";

export const RINKEBY_SUBGRAPH_URL =
  "https://api.thegraph.com/subgraphs/name/sherry2610/emberrinkeby";

export const GEORLI_SUBGRAPH_URL =
  "https://api.thegraph.com/subgraphs/name/mauwia/goerli-guild-hub";
// "https://api.thegraph.com/subgraphs/name/mauwia/ember-goerli";
// "https://api.thegraph.com/subgraphs/name/sherry2610/embergeorli";

export const ROUTES = {
  // home: "/",
  collections: "/",
  categories: "/collection/categories",
  marketplace: "/collection/category/marketplace",
  // profile: "/",
  nftDetails: "/scholar-details",
  listOnMarketPlace: "/listOnMarketPlace/nft",
  scholarProfile: "/scholarProfile",
  scholarBorrowedInventory: "/scholarProfile/borrowedInventory",
};

export const dummyCollectionPic =
  "https://res.cloudinary.com/dh3mg3o6h/image/upload/v1669726568/temp_x0q4vr.png";
export const dummyCollectionCover =
  "https://res.cloudinary.com/dh3mg3o6h/image/upload/v1669377281/profileCover_a0ojop.svg";

export const nftTempImage =
  "https://testnets.opensea.io/static/images/placeholder.png";

export const IN_INVENTORY = "Available";
export const ON_LEND1 = "On Lend";
export const ON_SELL = "On Sell";
export const ON_RENT = "On Rent";
export const ON_SUBLEND = "ON_SUBLEND";
export const ON_SUBRENT = "ON_SUBRENT";
export const CLAIMABLE = "CLAIMABLE";
export const BORROWED = "BORROWED";

export const ON_LEND = "On Loan"; // temporary

export const DURATION_FOR_BULK_LENDING = 1440000000000000;

export const YIELD_DISTRIBUTION = "/ember-test/yielddistribute";
export const GET_BORROWER_ACCOUNT_FOR_LENDER =
  "/ember-test/getBorrowersAccountForLender/";

export const GET_ACCUMULATED_YIELD = "/ember-test/getAccumaltedYield/";

export const LAYOUT_TYPES = {
  MY_NFTS: "myNfts",
  GUILD_HUB: "guild-hub",
};

export const REWARD_TOKEN_ADDRESS =
  "0x28Faa94634dFa50125AB18400487F42fB59E4734";

export const ROLES = {
  GUILD: "GUILD",
  SCHOLAR: "SCHOLAR",
};

export const Injected = new InjectedConnector({
  supportedChainIds: [1, 3, 4, 5, 42, 97, 56, 137, 80001],
});

export const SANDBOX_CASE = "0xa342f5d851e866e18ff98f351f2c6637f4478db5";
